<template>
  <a-spin style="height: 100%;" :spinning="spinning" :tip="msg">
    <h3 class="componentTitle">喜报预览</h3>
    <div>
      <!-- <h2 class="previewTitle">{{ newsData.newsTitle }}</h2> -->
      <div v-if="imgUrl">
        <div>
          <img ref="imgC" style="width: 400px;" :src="imgUrl" />
        </div>
        <a-button style="margin-top: 15px;" @click="saveImg">下载</a-button>
      </div>
      <!-- <p v-else>{{msg}}</p> -->
      <!--  style="display: none;width: 500px;"-->
      <div ref="previewBox" :class="'model' + modelKey" style="width: 500px;display: none;">
        <img :src="leftFixed" class="leftFixed" v-if="modelKey === '2'" />
        <img :src="rightFixed" class="rightFixed" v-if="modelKey === '2'" />
        <div style="text-align: center;padding-top: 2vw;" v-if="modelKey === '0'">
          <!-- logo -->
          <img :src="logo1" width="45%" />
        </div>
        <div style="text-align: center;padding-top: 2vw;padding-bottom: 2vw;" v-if="modelKey === '2'">
          <!-- logo -->
          <img :src="logo3" width="45%" />
        </div>
        <div style="text-align: center;padding-top: 1vw;" v-if="modelKey === '0'">
          <!-- 喜报标题图片 -->
          <img :src="title1" width="75%" />
        </div>
        <div class="content">
          <div style="text-align: center;margin-bottom: 15px;" v-if="modelKey === '1'">
            <!-- logo -->
            <img :src="logo2" width="45%" />
          </div>
          <div style="border: 3px solid #D7252D;border-left: none;border-right: none;padding-bottom: 2px;" v-if="modelKey === '1'">
            <img :src="titleStar" style="width: 100%;" />
          </div>
          <div style="text-align: center;padding-top: 1vw;" v-if="modelKey === '1'">
            <!-- 喜报标题图片 -->
            <div class="newsTitle">
              喜报
            </div>
          </div>
          <div class="titleBox" style="text-align: center;padding: 1vw 2vw;" v-if="modelKey === '2'">
            <!-- 喜报标题图片 -->
            <img :src="titleText" width="113%" style="margin-top: -3.7vw;margin-left: -1vw;" />
          </div>
          <p class="contentFactory" v-if="!visibleObj.factoryNameVisible">{{ newsData.factoryName }}</p>
          <!-- <p class="contentFactory" v-if="modelKey === '2' && !visibleObj.factoryNameVisible">{{ newsData.factoryName }}</p> -->
          <div :class="modelKey === '1' ? 'contentTitleBox' : ''">
            <h2 class="goodnewsTitle" v-if="modelKey === '0' || modelKey === '1'">{{ newsData.newsTitle }}</h2>
            <span class="newsLine" v-if="modelKey === '1' && !visibleObj.weightCostRatioVisible"></span>
            <h2 class="feedEfficiency" v-if="modelKey === '0' && !visibleObj.weightCostRatioVisible">
              <img class="beforeImg leftImg" :src="star" />
              <img class="beforeImg rightImg" :src="star" />
              料肉比{{ newsData.weightCostRatio }}
            </h2>
            <h2 class="feedEfficiency" v-if="modelKey === '1' && !visibleObj.weightCostRatioVisible">
              料肉比{{ newsData.weightCostRatio }}
            </h2>
            <h2 class="feedEfficiency" v-if="modelKey === '2'">
              <img class="beforeImg leftImg" :src="star" />
              <img class="beforeImg rightImg" :src="star" />
              {{ newsData.newsTitle }}
            </h2>
          </div>
          <div class="borderTopLeft">
            <template v-for="(el,i) in previewArr">
              <p
                :key="el.title" 
                :class="(i === previewArr.length - 1) && !widthCul ? 'width100' : el.className" 
                v-if="!visibleObj[`${el.field}Visible`]"
              >
                <span class="dataTitle borderColor">{{el.title}}</span>
                <span v-if="el.field === 'days'" class="dataText borderColor">
                  {{ moment(newsData && newsData.empiricalCycle ? newsData.empiricalCycle[0] : new Date()).format('YYYY年MM月DD日') }} -
                  {{ moment(newsData && newsData.empiricalCycle ? newsData.empiricalCycle[1] : new Date()).format('YYYY年MM月DD日') }}
                  （{{newsData ? newsData.days : ''}}天）
                </span>
                <span v-else class="dataText borderColor">{{newsData[el.field] || ''}}{{ unitStr(el) }}</span>
              </p>
            </template>
            
            <p class="borderColor comment" v-if="!visibleObj[`commentVisible`]">{{ newsData.comment }}</p>
          </div>
          <div style="display: flex;">
            <div class="previewImg previewLeft"><img :src="imageUrlLeft" /></div>
            <div class="previewImg previewRight"><img :src="imageUrlRight" /></div>
          </div>
          <h3 class="previewPropaganda" v-if="modelKey === '1'">{{ newsData.propaganda }}</h3>
          <!-- <h3 class="previewPropaganda" v-if="modelKey === '2'">{{ newsData.propaganda }}</h3> -->
        </div>
        <h3 class="previewPropaganda2" v-if="modelKey === '0' || modelKey === '2'">{{ newsData.propaganda }}</h3>
      </div>
    </div>
  </a-spin>
</template>

<script>
import { mapState } from 'vuex';
import html2canvas from 'html2canvas';
// import VueQr from 'vue-qr'

import QRCode from 'qrcodejs2'
// import QRCode from "qrcode"
import moment from 'moment';
export default {
  // components: {VueQr},
  props: {},
  data() {
    return {
      spinning: false,
      imgUrl: '',
      msg: '未生成预览',
      previewArr: [],
      allPreviewArr: [
        {title: '实验天数',field: 'days',className: 'width100',unit: '天',width: 100},
        {title: '饲料品种',field: 'feedVariety',className: 'width100',width: 100},
        {title: '实证头数',field: 'intoNum',className: 'width50',unit: '头',width: 50},
        {title: '实证阶段',field: 'positiveStage',className: 'width50',width: 50},
        {title: '初始体重',field: 'avgInitialWeight',className: 'width50',unitField: 'unitText',width: 50},
        {title: '结束体重',field: 'avgEndWeight',className: 'width50',unitField: 'unitText',width: 50},
        {title: '头均总增重',field: 'totalWeight',className: 'width50',unitField: 'unitText',width: 50},
        {title: '头均耗料',field: 'stageFeedCostTotal',className: 'width50',unitField: 'unitText',width: 50},
        {title: '平均日增重',field: 'avgWeightIncrement',className: 'width50',unitField: 'unitText2',width: 50},
        {title: '平均日采食量',field: 'avgFeedCost',className: 'width50',unitField: 'unitText',width: 50},
        // {title: '料肉比',field: 'weightCostRatio',className: 'width50',width: 50},
      ],
      star: require('@/assets/images/model/star.png'),
      logo1: require('@/assets/images/model/logo1.png'),
      logo2: require('@/assets/images/model/logo2.png'),
      logo3: require('@/assets/images/model/logo3.png'),
      title1: require('@/assets/images/model/title1.png'),
      title2: require('@/assets/images/model/title2.png'),
      stars: require('@/assets/images/model/stars.png'),
      leftFixed: require('@/assets/images/model/leftFixed.png'),
      rightFixed: require('@/assets/images/model/rightFixed.png'),
      titleText: require('@/assets/images/model/titleText.png'),
      titleStar: require('@/assets/images/model/titleStar.png'),
    }
  },
  watch: {
    generateCount(){
      this.init()
    },
  },
  computed: {
    ...mapState('news', ['newsData','generateCount','imageUrlLeft','imageUrlRight','modelKey','unit','visibleObj']),
    imgC(){
      return this.$refs.imgC
    },
    unitText(){
      let arr = ['斤/头','公斤/头']
      return arr[this.unit]
    },
    unitText2(){
      let arr = ['斤/天','公斤/天']
      return arr[this.unit]
    },
    widthCul(){
      let num = 0
      this.previewArr.forEach(el => {
        num += el.width
      })
      return num % 100 === 0
    },
  },
  created() {},
  mounted() {},
  methods: {
    moment,
    getPreviewList(){
      this.previewArr = []
      let lst = []
      this.allPreviewArr.forEach(el => {
        if(!this.visibleObj[`${el.field}Visible`]){
          lst.push(el)
        }
      })
      this.previewArr = lst
    },
    unitStr(el){
      let {unit,unitField} = el || {}
      let str = ''
      if(unit) str = unit
      if(unitField){
        str = this[unitField]
      }
      return str
    },
    generateQrCode() {
      new QRCode('QRCode', {
        // text: this.imgUrl, //页面地址 ,如果页面需要参数传递请注意哈希模式#
        width: 500,
        height: 500,
        colorDark: 'black ',
        colorLight: 'white',
        correctLevel: QRCode.CorrectLevel.L //二维码的纠错等级，等级越高，二维码呈现越复杂，同时被遮挡的多，也能扫出来
      })
    },
    init(){
      this.getPreviewList()
      this.spinning = true
      this.imgUrl = ''
      this.msg = '预览生成中'
      let x = this.$refs.previewBox
      setTimeout(() => {
        x.style.display = 'block'
        setTimeout(() => {
          x.style.display = 'none'
        }, 0);
        html2canvas(x,{}).then((canvas) => {
            this.spinning = false
            this.imgUrl = canvas.toDataURL();
        }).catch(() => {
          x.style.display = 'none'
          this.msg = '预览生成失败'
        });
      }, 100);
      
    },
    // base64 保存图片
    saveImg() {
      var base64 = this.imgUrl.toString(); // imgSrc 就是base64哈
      var byteCharacters = window.atob(
        base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
      );
      var byteNumbers = new Array(byteCharacters.length);
      for (var i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNumbers);
      var blob = new Blob([byteArray], {
        type: undefined,
      });
      var aLink = document.createElement("a");
      aLink.download = "图片名称.jpg"; //这里写保存时的图片名称
      aLink.href = URL.createObjectURL(blob);
      aLink.click();
    },
  },
}
</script>
<style lang='scss'>
.clearBoth{
  &:after{
    content: '';
    display: block;
    clear: both;
  }
}
.borderTop{
  border-top: 1px solid #efefef;
}
.width100{
  width: 100%;
  display: inline-flex;
  margin: 0;
  // border-bottom: 1px solid #efefef;
}
.width50{
  width: 50%;
  display: inline-flex;
  margin: 0;
  // border-bottom: 1px solid #efefef;
}
.previewImg{
  width: 50%;
  box-sizing: border-box;
  img{
    width: 100%;
  }
}
.previewLeft{
  padding: 10px 5px 10px 0;
}
.previewRight{
  padding: 10px 0 10px 5px;
}
.previewTitle{
  font-size: 20px;
  font-weight: bold;
  text-align: center;
}
.previewPropaganda{
  text-align: center;
  margin-bottom: 5px;
  font-weight: bold;
  font-size: 26px;
  color: #D7252D;
}
.previewPropaganda2{
  text-align: center;
  margin-bottom: 5px;
  margin-top: 5px;
  font-weight: bold;
  font-size: 26px;
  color: #FFCA2C;
}
.previewFactory{
  text-align: center;
  font-size: 13px;
}
</style>
<style lang='scss' scoped>
.model0{
  background: url('../../../assets/images/model/bg1.png') no-repeat,url('../../../assets/images/model/bg1-repeat.png') repeat;
  background-size: 100% 100%;
  padding-bottom: 20px;
  .goodnewsTitle{
    color: #350100;
    text-align: center;
    font-size: 30px;
    font-weight: bold;
  }
  .feedEfficiency{
    text-align: center;
    font-size: 36px;
    color: #C30E0B;
    position: relative;
    font-weight: bold;
    .beforeImg{
      width: 20px;
      position: absolute;
      top: 18px;
    }
    .leftImg{
      left: 0;
    }
    .rightImg{
      right: 0;
    }
  }
  .content{
    width: 94%;
    background-color: rgba(255,255,255,0.95);
    border-radius: 8px;
    margin-left: 3%;
    padding: 20px;
    // margin-top: 15px;
    .dataTitle{
      padding: 7px 5px;
      display: inline-block;
      background-color: #FFEDD6;
      width: 110px;
      color: #F98B00;
    }
    .dataText{
      padding: 7px 5px;
      display: inline-block;
      background-color: #FFF5E7;
      width: calc(100% - 110px);
      float: right;
    }
  }
  .borderColor{
    border-bottom: 1px solid #FFB04B;
    border-right: 1px solid #FFB04B;
  }
  .borderTopLeft{
    border-top: 1px solid #FFB04B;
    border-left: 1px solid #FFB04B;
  }
  .comment{
    padding: 15px 10px;
    text-align: center;
    background-color: #FFF5E7;
    color: #C30E0B;
    font-weight: bold;
    font-size: 18px;
  }
  
  .contentFactory{
    text-align: center;
    font-size: 20px;
    color: #434343;
    margin: 0;
  }
}
.model1{
  max-width: 700px;
  min-width: 500px;
  background-image: url('../../../assets/images/model/bg2.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding-top: 20px;
  padding-bottom: 20px;
  .content{
    width: 94%;
    background: url('../../../assets/images/model/contentTop.png') no-repeat left top,url('../../../assets/images/model/contentBottom.png') no-repeat left bottom, linear-gradient(transparent 0%,transparent 5%,#fff 5%,#fff 95%,transparent 95%,transparent 100%);
    background-size: contain;
    margin-left: 3%;
    padding: 20px;
    .starText{
      width: 50%;
      display: inline-block;
      padding-right: 10px;
      // display: flex;
      align-items: center;
      font-weight: bold;
      font-size: 22px;
      text-align: center;
      text-align: justify;
      text-align-last: justify;
      text-justify: distribute-all-lines;
    }
    .newsTitle{
      width: 95%;
      height: 190px;
      margin: auto;
      font-size: 8em;
      color: #fff;
      align-items: center;
      text-align: center;
      font-weight: 600;
      background-image: url('../../../assets/images/model/title2.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
    .dataTitle{
      padding: 7px 5px;
      display: inline-block;
      background-color: #fff;
      width: 105px;
      color: #C30E0B;
    }
    .dataText{
      padding: 7px 5px;
      display: inline-block;
      background-color: #fff;
      width: calc(100% - 105px);
      float: right;
      color: #000000;
    }
    .comment{
      padding: 15px 10px;
      text-align: center;
      background-color: #fff;
      color: #040100;
      font-weight: bold;
      font-size: 18px;
      margin-bottom: 10px;
    }
    .borderColor{
      border-bottom: 2px solid #D7252D;
      border-right: 2px solid #D7252D;
    }
    .borderTopLeft{
      border-top: 2px solid #D7252D;
      border-left: 2px solid #D7252D;
    }
    .contentTitleBox{
      border: 4px solid #D7252D;
      margin-top: 20px;
      margin-bottom: 10px;
    }
    .goodnewsTitle{
      color: #350100;
      text-align: center;
      font-size: 24px;
      font-weight: bold;
      background-color: #fff;
      width: 94%;
      margin-left: 3%;
      margin-top: -22px;
    }
    .newsLine{
      height: 5px;
      width: 90%;
      margin-left: 5%;
      background-color: #D7252D;
      display: inline-block;
      margin-top: 10px;
    }
    .feedEfficiency{
      background-color: #fff;
      width: 50%;
      margin-left: 25%;
      margin-top: -35px;
      text-align: center;
      font-size: 36px;
      color: #C30E0B;
      position: relative;
      .beforeImg{
        width: 20px;
        position: absolute;
        top: 18px;
      }
      .leftImg{
        left: 0;
      }
      .rightImg{
        right: 0;
      }
    }
    .contentFactory{
      text-align: center;
      font-size: 20px;
      color: #C30E0B;
      margin: 10px 0 10px;
    }
  }
}
.model2{
  max-width: 700px;
  min-width: 500px;
  background-image: url('../../../assets/images/model/bg3.png');
  background-size: 100% 100%;
  padding-bottom: 20px;
  position: relative;
  .leftFixed{
    position: absolute;
    top: 0;
    left: 0;
    width: 7.5vw;
  }
  .rightFixed{
    position: absolute;
    bottom: 0;
    right: 0;
    width: 6vw;
  }
  .goodnewsTitle{
    color: #350100;
    text-align: center;
    font-size: 30px;
    font-weight: bold;
  }
  .feedEfficiency{
    position: relative;
    text-align: center;
    font-size: 24px;
    color: #C30E0B;
    position: relative;
    padding: 0 20px;
    font-weight: bold;
    width: 80%;
    margin-left: 10%;
    .beforeImg{
      width: 20px;
      position: absolute;
      top: 50%;
      margin-top: -10px;
    }
    .leftImg{
      left: -10%;
    }
    .rightImg{
      right: -10%;
    }
  }
  .content{
    width: 94%;
    background-color: rgba(255,255,255,0.95);
    border-radius: 8px;
    margin-left: 3%;
    padding: 3vw 20px;
    // margin-top: 15px;
    .dataTitle{
      padding: 7px 5px;
      display: inline-block;
      background-color: #FFEDD6;
      width: 105px;
      color: #F98B00;
    }
    .dataText{
      padding: 7px 5px;
      display: inline-block;
      background-color: #FFF5E7;
      width: calc(100% - 105px);
      float: right;
    }
  }
  .borderColor{
    border-bottom: 1px solid #FFB04B;
    border-right: 1px solid #FFB04B;
  }
  .borderTopLeft{
    border-top: 1px solid #FFB04B;
    border-left: 1px solid #FFB04B;
  }
  .comment{
    padding: 15px 10px;
    text-align: center;
    background-color: #FFF5E7;
    color: #040100;
    font-weight: bold;
    font-size: 18px;
  }
  .contentFactory{
    text-align: center;
    font-size: 20px;
    color: #434343;
    margin: 5px 0 3px 0;
  }
  .titleBox{
    background-image: url('../../../assets/images/model/titleBox.png');
    background-size: contain;
    background-repeat: no-repeat;
    width: 100%;
    // height: 13.8vw;
  }
}
  .font12{
    font-size: 12px;
  }
</style>